import { column } from 'helpers/styles/grid'
import { COLORS } from 'helpers/globals'

export default {
  container: {
    flex: '1 1 0px',
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center'
  },
  normalLabel: {
    lineHeight: '2rem',
    color: 'black',
    textAlign: 'center',
    height: '2.5rem'
  },
  inputWrapper: {
    flex: '1 1 auto',
    marginLeft: '1rem'
  },
  suffix: {
    marginLeft: '1rem',
    textAlign: 'center',
    lineHeight: '30px',
    height: 30
  },
  inputField: {
    width: '70px !important'
  },
  infoTooltip: {
    marginLeft: '1rem',
    color: `${COLORS.primary}`
  },
  inputGlow: {
    width: '70px !important',
    borderColor: `${COLORS.primary} !important`,
    boxShadow: '0 0 1px rgba(66, 139, 202, 1) !important'
  }
}



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/DowntiltInput/style.js